<template>
  <!-- Overlay Start -->
  <div class="overlay"></div>
  <!-- Overlay End -->

  <!-- Privacy Policy Start -->
  <div class="section login-section-padding">
    <div class="section-padding-02 mt-n10">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <!-- Privacy Policy Content Start -->
            <div class="about-content width-100">
              <h2 class="main-title">Privacy Notice & Cookies Policy</h2>
              
              <p>COLREGs (referred to as "COLREGs", "we", "us" or "our" in this Privacy Notice & Cookies Policy) respects your privacy and is committed to protecting your Personal Data. This Privacy & Cookies Policy will inform you as to how we look after your Personal Data when you visit our website (regardless of where you visit it from) and tell you about your privacy rights and how the law protects you.</p>

              <h3>01. Purpose of this Privacy Notice & Cookies Policy</h3>
              <p>This Privacy Notice & Cookies Policy sets out how COLREGs uses and protects any information that you provide when using this website.</p>
              <p>COLREGs's website is not intended for children and we do not knowingly collect data relating to children.</p>

              <h3>02. Data Controller</h3>
              <p>COLREGs is the controller and responsible for your Personal Data. If you have any questions in relation to this Privacy Notice & Cookies Policy please contact us direct.</p>
              
              <p><strong>Email:</strong> admin@thecolregs.com</p>
              <p><strong>Office Address:</strong>47 Knoll Drive, London, England, N14 5LU</p>

              <h3>03. Personal Information Collected</h3>
              <p>Personal Data, or personal information, means any information about an individual from which that person can be identified. It does not include data where the identity has been removed (anonymous data).</p>
              
              <p>We may on occasion or in the future have cause to collect, use, store and transfer different kinds of Personal Data about you which we have grouped together as follows:</p>

              <p><strong>Identity Data:</strong> includes first name, maiden name, last name or similar identifier.</p>
              
              <p><strong>Contact Data:</strong> includes email address and telephone numbers.</p>
              
              <p><strong>Technical Data:</strong> includes browser type and version, time zone setting and location, browser plug-in types and versions, operating system and platform and other technology on the devices you use to access this website.</p>
              
              <p><strong>Profile Data:</strong> includes 'Get in touch' information.</p>
              
              <p><strong>Usage Data:</strong> includes information about how you use our website.</p>

              <p>We do not collect any Special Categories of Personal Data about you on our website (this includes details about your race or ethnicity, religious or philosophical beliefs, sex life, sexual orientation, political opinions, trade union membership, information about your health and genetic and biometric data). We do not collect any information about criminal convictions and offences on the website.</p>

              <h3>04. Information Collection</h3>
              <p>We use different methods to collect data from and about you including through:</p>

              <h4>Direct Interactions</h4>
              <p>You may give us your name, address, company and email address by filling in forms or by corresponding with us by email. This includes Personal Data you provide when you request further information on COLREGs or give us feedback.</p>

              <h4>Automated Technologies or Interactions</h4>
              <p>As you interact with our website, we may automatically collect Technical Data about your browsing actions and patterns. We collect this Personal Data by using cookies, and other similar technologies.</p>

              <h4>Third Parties or Publicly Available Sources</h4>
              <p>We may receive data about you from various third parties and public sources including analytics providers and search information providers based outside of the EU.</p>

              <h4>Google Analytics</h4>
              <p><a href="https://analytics.google.com/" target="_blank" rel="noopener">Google Analytics</a> cookies store information in order to report on website trends. The information collected includes the pages a visitor visits, the time a visit occurred, whether the visitor has been to the site before and what site referred the visitor to the web page. The cookies report website trends; they do not identify individual visitors and visitors cannot be tracked across multiple sites.</p>

              <p>To opt out, you can disable cookies in your browser and you can install the <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener">Google Analytics Opt-out Add-on</a>, which prevents Google Analytics from collecting information about website visits. To find out more about analytics privacy visit <a href="https://policies.google.com/technologies/partner-sites" target="_blank" rel="noopener">Google Analytics</a>.</p>

              <h4>LinkedIn Insight Tag</h4>
              <p>The LinkedIn Insight Tag is a JavaScript code that we may in future add to our website to enable campaign reporting and to help us analyse our website visitors. We may use the LinkedIn Insight Tag to track conversions, re-target website visitors, and gain insights about members that engage with our LinkedIn adverts.</p>
              
              <p>The LinkedIn Insight Tag collects IP address information, timestamp, and events such as page views. All data is encrypted. The LinkedIn browser cookie is stored in a visitor's browser until they delete the cookie or the cookie expires (there's a rolling six-month expiration from the last time the visitor's browser loaded the Insight Tag).</p>
              
              <p>You can opt out of cookies from LinkedIn on your LinkedIn settings page and we recommend you read their Cookie Policy for more information.</p>

              <h3>05. Information Use</h3>
              <p>We will only use your Personal Data when the law allows us to. Most commonly, we will use your Personal Data where it is necessary for our legitimate interests (or those of a third party) and your interests and fundamental rights do not override those interests.</p>

              <h4>Cookies</h4>
              <p>Like many web sites, we use 'cookies' to enable us to personalise your visits to this website, simplify any future signing-in procedure, keep track of your preferences and to track the usage of this web site. Cookies are small pieces of information that are stored in the hard drive of your computer by your browser.</p>
              
              <p>The first time you visit this website after this policy becomes effective or at any other time after you have deleted our cookies from your device, you will be presented with a notice informing you that our sites use cookies. That notice will include a link to this policy. If you decide to continue using this website after being presented with that notice, we will assume that we have your consent to set cookies as described in this policy.</p>
              
              <p>Your browser will have the option to prevent websites using cookies (your browser's help screen or manual will tell you how to do this), but please note that this may reduce the functionality of this website and other websites. Like all websites, our servers automatically record 'log files' containing information about the volume and characteristics of our website traffic e.g. IP address, numbers of pages viewed, length of time spent on site. We use log files to build pictures of how our website is used that help us to monitor and improve the service. We cannot identify you from your log files.</p>

              <h4>Change of Purpose</h4>
              <p>We will only use your Personal Data (eg. name) for the purposes for which we collected it, unless we reasonably consider that we need to use it for another reason and that reason is compatible with the original purpose.</p>
              
              <p>If we need to use your Personal Data for an unrelated purpose, we will notify you and we will explain the legal basis which allows us to do so.</p>
              
              <p>Please note that we may process your Personal Data without your knowledge or consent, in compliance with the above rules, where this is required or permitted by law.</p>

              <h3>06. Who Has Access to the Information You Provide or We Collect?</h3>
              <p>We do not allow our third-party service providers to use your Personal Data for their own purposes and only permit them to process your Personal Data for specified purposes and in accordance with our instructions.</p>
              
              <p>Access to, changing or removing the information we hold: if you wish to update the details that you have previously submitted, please email us at: <strong>admin@thecolregs.com</strong></p>

              <h3>07. Security</h3>
              <p>We strive to ensure the security, integrity and privacy of personal information submitted to our sites, and we review and update our security measures in light of current technologies.</p>
              
              <p>If, at any time, you discover that information held about you is incorrect, you should contact us and we will correct the information we hold about you.</p>
              
              <p>We have put in place procedures to deal with any suspected Personal Data breach and will notify you and any applicable regulator of a breach where we are legally required to do so.</p>

              <h3>08. Data Retention</h3>
              <p>We will only retain your Personal Data for as long as necessary to fulfil the purposes we collected it for, including for the purposes of satisfying any legal, accounting, or reporting requirements.</p>
              
              <p>To determine the appropriate retention period for Personal Data obtained on the website, we consider the amount, nature, and sensitivity of the Personal Data, the potential risk of harm from unauthorised use or disclosure of your Personal Data, the purposes for which we process your Personal Data and whether we can achieve those purposes through other means, and the applicable legal requirements.</p>
              
              <p>Please also refer to the <a href="https://support.google.com/analytics/answer/7667196" target="_blank" rel="noopener">Google Analytics Data Retention statement</a>.</p>

              <h3>09. Your Legal Rights</h3>
              <p>You have rights under data protection laws in relation to your Personal Data, including:</p>
              
              <ul>
                <li>Request information on how we process your Personal Data.</li>
                <li>Request access to your Personal Data.</li>
                <li>Request rectification of your Personal Data.</li>
                <li>Request erasure of your Personal Data.</li>
                <li>Object to processing of your Personal Data.</li>
                <li>Request restriction of processing your Personal Data.</li>
                <li>Request transfer of your Personal Data (data portability).</li>
                <li>Right to withdraw consent.</li>
                <li>Challenge automated decision making.</li>
              </ul>

              <p>You have the right to make a complaint at any time to the Information Commissioner's Office (ICO), the UK supervisory authority for data protection issues (www.ico.org.uk). We would, however, appreciate the chance to deal with your concerns before you approach the ICO so please contact us in the first instance.</p>

              <h4>No Fee Usually Required</h4>
              <p>You will not have to pay a fee to access your Personal Data (or to exercise any of the other rights). However, we may charge a reasonable fee if your request is clearly unfounded, repetitive or excessive, or we may refuse to comply with your request in these circumstances.</p>

              <h4>What We May Need From You</h4>
              <p>We may request specific information from you to help us confirm your identity and validate your right to access your Personal Data (or to exercise any of your other rights). This is a security measure to ensure that Personal Data is not disclosed to any person who has no right to receive it. We may also ask you for further information in relation to your request to accelerate our response. If you elect a representative to act on your behalf we will have to verify both their authority to represent you and their identity.</p>

              <h4>Time Limit to Respond</h4>
              <p>We try to respond to all legitimate requests within 30 days. Occasionally, it may take us longer than this if your request is complex or you have made multiple of requests. In this case, we will notify you of our intention to extend this period within the first 30 days and keep you updated throughout the process.</p>

              <h4>Links to Other Websites</h4>
              <p>This website may include links to third-party websites, plug-ins and applications. However, once you have used these links to leave the site, you should note that we do not have any control over that other website. Therefore, we cannot be responsible for the protection and privacy of any information which you provide whilst visiting such sites and such sites are not governed by this Privacy Notice & Cookies policy.</p>

            </div>
            <!-- Privacy Policy Content End -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Privacy Policy End -->
</template>

<script>
export default {
  name: 'PrivacyPolicy'
};
</script>

<style scoped>
.about-content {
  line-height: 1.8;
}

.about-content h2.main-title {
  font-size: 2.5rem;
  margin-bottom: 1.5rem;
  color: #2d7a4e;
}

.about-content h3 {
  font-size: 1.5rem;
  margin-top: 2rem;
  margin-bottom: 1rem;
  color: #2d7a4e;
  font-weight: 600;
}

.about-content h4 {
  font-size: 1.2rem;
  margin-top: 1.5rem;
  margin-bottom: 0.8rem;
  color: #333;
  font-weight: 600;
}

.about-content p {
  margin-bottom: 1rem;
  color: #555;
}

.about-content ul {
  margin-left: 2rem;
  margin-bottom: 1rem;
}

.about-content ul li {
  margin-bottom: 0.5rem;
  color: #555;
}

.about-content strong {
  color: #2d7a4e;
  font-weight: 600;
}
</style>
